const Line = ({ pointA, pointB, nightMode, lineWidth = 2 }) => {
  const { x: x1, y: y1 } = pointA;
  const { x: x2, y: y2 } = pointB;

  // Calculate the length and angle of the line
  const length = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

  return (
    <div
      style={{
        position: "absolute",
        left: `${x1}px`,
        top: `${y1}px`,
        width: `${length}px`,
        height: `${lineWidth}px`,
        backgroundColor: nightMode ? "#c2c4c2" : "#010101",
        transform: `rotate(${angle}deg)`,
        transformOrigin: "0 0",
      }}
    />
  );
};

export default Line;
